import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18next';
import { CommentLabelText } from './CommenLabelStyles';

const CommentLabel = ({ type }) => {
  const generateLabelText = (commentType) => {
    let returnValue = null;
    switch (commentType) {
      case 'latest':
        returnValue = I18n.t('commentLabelLatest');
        break;
      default:
        returnValue = null;
      // code block
    }
    return returnValue;
  };

  const labelText = generateLabelText(type);
  return <>{labelText && <CommentLabelText>{labelText}</CommentLabelText>}</>;
};

CommentLabel.propTypes = {
  type: PropTypes.string
};

CommentLabel.defaultProps = {
  type: null
};

export default CommentLabel;
